import RouteTemplate from 'ember-route-template';

import ErrorContact from 'rise-ui/components/error-contact.gjs';
import ErrorPage from 'rise-ui/components/error-page.gjs';

export default RouteTemplate(<template>
  <ErrorPage class="qa-error-announcement-not-found" as | error |>
    <error.title>Announcement Not Found</error.title>
    <error.subtitle>We're sorry, but that announcement could not be found.</error.subtitle>
    <error.content><ErrorContact/></error.content>
  </ErrorPage>
  {{outlet}}
</template>);
